// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo } from 'react';
import { useState } from '@hookstate/core/dist';
import { $clone, defaultActionFormatter } from '../../../../vodea/utilities';
import { Link, useLocation } from 'react-router-dom';
import CustomerRepository from '../../../../repositories/CustomerRepository';
import { AxiosError, AxiosResponse } from 'axios';
import { showToast } from '../../../../vodea/utilities/helpers/global';
import _ from 'lodash';
import moment from 'moment';
import VuiActionModal from '../../../../vodea/@vodea-ui/components/Modal/VuiActionModal';
import { useTranslation } from 'react-i18next';
import MembershipRepository from '../../../../repositories/MembershipRepository';
import VuiSelect from '../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import useIsMounted from '../../../../vodea/utilities/hooks/useIsMounted';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores';
import useScroll from '../../../../vodea/utilities/hooks/useScroll';
import DataTableInfiniteScroll, { ITableColumn } from '../../../../vodea/@vodea-ui/components/DataTableInfiniteScroll';
import VuiSearch from '../../../../vodea/@vodea-ui/components/VuiSearch';
import fileDownload from 'js-file-download';
import { VuiButton } from '../../../../vodea/@vodea-ui/components/VuiButton';

const ContactCustomer: React.FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isMounted = useIsMounted();

  const tableDeleteId = useState(0);
  const showActionModal = useState(false);
  const permissions = useSelector((state: RootState) => state.permission.permission.permissions);
  const { isBottom } = useScroll();
  const [hasMore, setHasMore] = React.useState<boolean>(false);
  const [isFetchingMoreData, setIsFetchingMoreData] = React.useState<boolean>(false);
  const [hasInitialize, setHasInitialize] = React.useState<boolean>(false);
  const [totalData, setTotalData] = React.useState<number>(0);

  const tableOnClickDelete = (id: number) => {
    tableDeleteId.set(id);
    showActionModal.set(true);
  };

  const selectedMembership = useState(null);

  const tableConfig = useState({
    search: '',
    page: 1,
    per_page: 10,
    sorted_by: 'desc',
    order_by: 'created_at',
    total: 0,
    loading: false,

    // Additional
    membership: ''
  });

  const tableData = useState<any[]>([]);

  const tableHandleOnContinue = (e: React.MouseEvent) => {
    CustomerRepository.delete(tableDeleteId.get())
      .then((response: AxiosResponse) => {
        showToast(response.data.message, 'success');
        showActionModal.set(false);
        getTableData(true);
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const tableColumns: ITableColumn[] = [
    {
      dataField: 'number',
      text: 'ID'
    },
    {
      dataField: 'name',
      text: 'Customer'
    },
    {
      dataField: 'membership_name',
      text: 'Membership'
    },
    {
      dataField: 'created_at',
      text: 'Created',
      render: (cell: any) => {
        return moment(cell).format('D MMMM YYYY h:m A');
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      render: defaultActionFormatter,
      formatExtraData: {
        location: location.pathname,
        actionDelete: tableOnClickDelete,
        permission: 'customer',
        permissions: permissions
      }
    }
  ];

  const changeTableLoading = (val: boolean) => {
    if (isMounted.current) {
      tableConfig.loading.set(val);
    }
  };

  const getTableData = async (reset: boolean = false, forNextPage: boolean = false) => {
    if (reset) tableConfig.page.set(1);
    if (isMounted.current && forNextPage) {
      setIsFetchingMoreData(true);
      tableConfig.page.set(tableConfig.page.get() + 1);
    } else {
      changeTableLoading(true);
    }

    if (isMounted.current) {
      setHasMore(true);
    }

    const conf = _.omit($clone(tableConfig.value), 'loading');

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    if (isMounted.current && !forNextPage) tableData.set([]);

    await CustomerRepository.all(params)
      .then((response: AxiosResponse) => {
        if (isMounted.current) {
          const { data: responseData } = response.data;
          tableData.merge(responseData);
          setIsFetchingMoreData(false);
          setHasInitialize(true);
          if (responseData.length < tableConfig.per_page.get()) {
            setHasMore(false);
          }
          if (reset) {
            setTotalData(response.data.total_data);
          }
        }

        changeTableLoading(false);
      })
      .catch((e: AxiosError) => {
        if (e.isAxiosError) showToast(e.message, 'error');
        if (isMounted.current) {
          setHasInitialize(true);
          setIsFetchingMoreData(false);
          setTotalData(0);
        }
        changeTableLoading(false);
      });
  };

  useMemo(() => {
    getTableData(true);
  }, []);

  useMemo(() => {
    if (isBottom && hasInitialize && !isFetchingMoreData && hasMore) {
      getTableData(false, true);
    }
  }, [isBottom]);

  const handleTableSearch = (value: string) => {
    if (isMounted.current) {
      tableConfig.search.set(value);
      getTableData(true);
    }
  };

  const loadingExport = useState(false);

  const handleExport = async () => {
    loadingExport.set(true);

    const conf = _.omit($clone(tableConfig.value), ['loading', 'total']);

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    CustomerRepository.export(params).then((response: any) => {
      fileDownload(response.data, 'contact-report.xls');
      loadingExport.set(false);
    });
  };

  const breadcrumbList = [
    {
      label: t('Contact'),
      link: '/contact'
    },
    {
      label: t('Customer'),
      link: '/contact/customer'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Customer</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{t('Customer')}</h3>

        <div className={'btn-wrapper d-flex align-items-center'}>
          <div className={'action-wrapper'}>
            {permissions.includes('customer.store') ? (
              <Link to={'/contact/customer/create'} className={'action-item'}>
                <button type={'button'} className={'btn btn-primary'}>
                  <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                  {t('Create Customer')}
                </button>
              </Link>
            ) : null}

            {permissions.includes('report.contact') ? (
              <VuiButton forSubmit={false} label={t('Export')} loading={loadingExport.get()} onClick={handleExport} />
            ) : null}
          </div>
        </div>
      </div>

      {permissions.includes('customer.show') ? (
        <div className={'card-paper'}>
          <div className={'card-content'}>
            <div className={'default-filter-section'}>
              <div className={'filter-item filter-special type-search'}>
                <VuiSearch value={tableConfig.search.get()} callback={handleTableSearch} />
              </div>

              <div className={'filter-item'}>
                <div className='form-select-wrapper'>
                  <VuiSelect
                    clearable={true}
                    selectRepository={MembershipRepository}
                    defaultValue={selectedMembership.get()}
                    onChange={val => {
                      selectedMembership.set(val);
                      tableConfig.membership.set(_.get(val, 'id', null));
                      getTableData(true);
                    }}
                    isMulti={false}
                  />
                </div>
              </div>
            </div>

            <DataTableInfiniteScroll
              columns={tableColumns}
              data={tableData.get()}
              propKey={'id'}
              isLoading={tableConfig.loading.get()}
              isFetchingMoreData={isFetchingMoreData}
              totalData={totalData}
            />
          </div>

          <VuiActionModal show={showActionModal.get()} onHide={() => showActionModal.set(false)} onContinue={tableHandleOnContinue} />
        </div>
      ) : null}
    </>
  );
};

export default ContactCustomer;
